import React from "react";
import { FadeLoader } from "react-spinners";
interface ILoaderProps {
  loading?: boolean;
  color?: string;
  cssOverride?: React.CSSProperties;
  speedMultiplier?: number;
}
function LoaderWithoutMemo(props: ILoaderProps) {
  const { loading, color, cssOverride, speedMultiplier } = props;

  return (
    <div className="grid h-screen place-items-center">
      <FadeLoader
        loading={loading}
        color={color}
        cssOverride={cssOverride}
        speedMultiplier={speedMultiplier}
      />
    </div>
  );
}

// memoization
const Loader = React.memo(LoaderWithoutMemo);
// redux wiring

// exports
export default Loader;
